export default "__VITE_ASSET__bc778d43__"